import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { selectTermsAndConditions } from '../../shared/layout/main.selectors';
import { AppState } from '../../reducers';
import { LoadStaticDataAction } from '../../shared/layout/main.actions';
import { printTermsAndConditions } from '../../shared/utils';


@Component({
  standalone: false,
  selector: 'dsp-terms-of-use',
  templateUrl: 'terms-of-use.container.html',
  styleUrls: ['terms-of-use.container.scss']
})
export class TermsOfUseContainerComponent {
  public terms$: Observable<string>;

  constructor(
    private readonly store: Store<AppState>
  ) {
    this.store.dispatch(new LoadStaticDataAction('au'));
    this.terms$ = this.store.pipe(select(selectTermsAndConditions));
  }
  public termsAndConditions(termsAndConditionDivId) {
    return printTermsAndConditions(termsAndConditionDivId);

  }
}
